import { render, staticRenderFns } from "./BtnIcon.vue?vue&type=template&id=06d386cc&functional=true"
import script from "./BtnIcon.vue?vue&type=script&lang=js"
export * from "./BtnIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports